import { PatientConsentContext } from '@/context/PatientConsentProvider';
import { usePatientConsentStatus } from '@/hooks/patient/usePatientConsentStatus';
import { viteAppEnv } from '@montugroup/circuit-shared/constants/env';
import type { Dispatch, SetStateAction } from 'react';
import { useContext } from 'react';
import { PatientConsentDialog } from './PatientConsentDialog';

interface PatientConsentProps {
  setPatientConsentSubmitted: Dispatch<SetStateAction<boolean>>;
}

export const PatientConsent = ({ setPatientConsentSubmitted }: PatientConsentProps) => {
  const { submitConsent } = usePatientConsentStatus(setPatientConsentSubmitted);
  const { requiresConsentSubmission, requireReload } = useContext(PatientConsentContext);

  // Disable this dialog when developing locally, to improve DX.
  const isDev = viteAppEnv() === 'development';
  if (isDev) {
    return null;
  }

  if (!requiresConsentSubmission) {
    return null;
  }

  return (
    <PatientConsentDialog isOpen={requiresConsentSubmission} onSubmit={submitConsent} requireReload={requireReload} />
  );
};
